import React from 'react';
import styles from './Workflows.module.scss';
import {default as tabStyles} from '../tabs/Tabs.module.scss';
import { NavLink, Switch, Route, Redirect } from "react-router-dom";

import Tabs from '../tabs/Tabs';
import Translations from '../translations/Translations';
import Configuration from './Configuration';
import List from './List';

export default function Workflows(props) {
    
    return (
        <section className={styles.FocusSpace}>
            <Tabs>
                <NavLink to="/workflows/configuration" className={tabStyles.Tab} activeClassName={tabStyles.active}> Workflow Configuration </NavLink>
                <NavLink to="/workflows/list" className={tabStyles.Tab} activeClassName={tabStyles.active}> All Workflows </NavLink>
            </Tabs>
            <Switch>
                <Route path="/workflows/configuration" component={() => <Configuration />} />
                <Route path="/workflows/list" component={() => <List />} />
                <Route render={() => <Redirect to="/workflows/configuration" />}/>
            </Switch>
            <Translations />
        </section>
    );
}